import React, { useMemo } from "react";

function PieChart({ items = [] }) {
  const normalized = useMemo(() => {
    const total = items.reduce((sum, item) => sum + Number(item.value || 0), 0) || 1;
    let offset = 0;

    return items.map((item) => {
      const value = Number(item.value || 0);
      const pct = value / total;
      const segment = {
        ...item,
        pct,
        offset,
      };
      offset += pct;
      return segment;
    });
  }, [items]);

  const size = 240;
  const center = size / 2;
  const radius = 88;
  const circumference = 2 * Math.PI * radius;

  return (
    <div style={{ display: "grid", gridTemplateColumns: "230px 1fr", gap: 18, alignItems: "center" }}>
      <svg viewBox={`0 0 ${size} ${size}`} width={size} height={size} role="img" aria-label="Pie chart">
        <circle cx={center} cy={center} r={radius} stroke="rgba(255,255,255,0.08)" strokeWidth="28" fill="none" />
        {normalized.map((item) => (
          <circle
            key={item.label}
            cx={center}
            cy={center}
            r={radius}
            stroke={item.color || "#8bffb0"}
            strokeWidth="28"
            strokeDasharray={`${item.pct * circumference} ${circumference - item.pct * circumference}`}
            strokeDashoffset={-item.offset * circumference}
            strokeLinecap="round"
            fill="none"
            transform={`rotate(-90 ${center} ${center})`}
            style={{ transition: "stroke-dasharray 500ms ease, stroke-dashoffset 500ms ease" }}
          />
        ))}
        <circle cx={center} cy={center} r={radius - 24} fill="#080a05" />
        <text x={center} y={center - 4} fill="#fff" fontSize="26" fontWeight="800" textAnchor="middle">
          {normalized.reduce((sum, item) => sum + Number(item.value || 0), 0).toLocaleString("en-IN")}
        </text>
        <text x={center} y={center + 18} fill="rgba(255,255,255,0.56)" fontSize="12" textAnchor="middle">
          total mix
        </text>
      </svg>

      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {normalized.map((item) => (
          <div key={item.label} style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <span style={{ width: 12, height: 12, borderRadius: 99, background: item.color || "#8bffb0", flexShrink: 0 }} />
            <div style={{ flex: 1 }}>
              <div style={{ display: "flex", justifyContent: "space-between", gap: 12, fontSize: 13 }}>
                <span style={{ color: "#fff", fontWeight: 700 }}>{item.label}</span>
                <span style={{ color: "rgba(255,255,255,0.72)", fontWeight: 700 }}>{Math.round(item.pct * 100)}%</span>
              </div>
              <div style={{ height: 6, borderRadius: 99, background: "rgba(255,255,255,0.08)", marginTop: 8, overflow: "hidden" }}>
                <div
                  style={{
                    width: `${Math.max(Math.round(item.pct * 100), 4)}%`,
                    height: "100%",
                    borderRadius: 99,
                    background: item.color || "#8bffb0",
                    transition: "width 500ms ease",
                  }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default React.memo(PieChart);
